// FutureLab
import { ChatRoom } from '../components/chat/ChatRoom';

export function ChatRoomPage() {
	return (
		<div className="chat-room-page flex h-[calc(100dvh-60px)] w-full min-w-0 overflow-hidden">
			<ChatRoom />
		</div>
	);
}
